/**
 * Part of starter project.
 *
 * @copyright  Copyright (C) 2021 __ORGANIZATION__.
 * @license    __LICENSE__
 */

import u from '@main';

u.$ui.bootstrap.tooltip();

const formSelector = '#contact-form';

u.formValidation()
  .then(() => u.$ui.disableOnSubmit(formSelector));
u.form(formSelector).initComponent();
u.$ui.keepAlive(location.href);

const treatmentCateOption = document.getElementById('input-item-details-treatment_category');

treatmentCateOption.addEventListener('change', (e) => {
  u.$ui.listDependent(
    '#input-item-details-treatment',
    '#input-item-details-treatment_category',
    {
      text_field: 'title',
      value_field: 'id',
      ajax: {
        url: u.route('treatment_ajax_list')
      }
    }
  );
});

const areaOption = document.getElementById('input-item-details-facility_area');

areaOption.addEventListener('change', (e) => {
  u.$ui.listDependent(
    '#input-item-details-facility',
    '#input-item-details-facility_area',
    {
      text_field: 'title',
      value_field: 'id',
      ajax: {
        url: u.route('facility_ajax_list')
      }
    }
  );
});
